import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import { v4 as uuid } from "uuid";
import GroupEdgesSource from "../../types/groupEdgesSource";
export default (graphComponentRef, edgeSource, nodeFrom, nodeTo) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) ||
        !nodeFrom ||
        !nodeTo ||
        !edgeSource ||
        isEmpty(edgeSource))
        return undefined;
    let tag;
    if (isArray(edgeSource)) {
        tag = edgeSource.length > 1 ? new GroupEdgesSource(uuid(), edgeSource) : edgeSource[0];
    }
    else {
        tag = edgeSource;
    }
    return graphComponentRef.current.graph.createEdge({
        source: nodeFrom,
        target: nodeTo,
        tag
    });
};
